export default __webpack_public_path__ + "static/media/student-enter-answer-mc.8e98ebcd.gif";